import { useScrollAnimation } from '../../../hooks/useScrollAnimation';

export default function TrustBar() {
  const { ref, isVisible } = useScrollAnimation({ threshold: 0.3 });

  const companies = [
    { name: 'Sansan', icon: '', logo: 'https://static.readdy.ai/image/39cbf484d561e1f62e3c6532cd56d730/157cbbc086070ae9b9edbe1cb652ad7a.png' },
    { name: 'Bynder', icon: '', logo: 'https://static.readdy.ai/image/39cbf484d561e1f62e3c6532cd56d730/ac1044dc574acae4f300082a179b57e7.png' },
    { name: 'Doctify', icon: '', logo: 'https://static.readdy.ai/image/39cbf484d561e1f62e3c6532cd56d730/02e36c31ff301b130393937a62b99dab.png' },
    { name: 'KJCgear', icon: '', logo: 'https://static.readdy.ai/image/39cbf484d561e1f62e3c6532cd56d730/05dfc07e76670d86839b0716c7be6449.png' },
    { name: 'Ubitus', icon: '', logo: 'https://static.readdy.ai/image/39cbf484d561e1f62e3c6532cd56d730/6d4286f901be45237a04ce16a9d50b95.png' },
    { name: 'Stylaverse', icon: '', logo: 'https://static.readdy.ai/image/39cbf484d561e1f62e3c6532cd56d730/7107e2bcecd5d4f883bbc24cae44380a.png' }
  ];

  return (
    <section className="bg-white py-10 md:py-14 border-b border-[#F0EDE6]">
      <div
        ref={ref}
        className="max-w-[1200px] mx-auto px-5 md:px-8"
        style={{
          opacity: isVisible ? 1 : 0,
          transform: isVisible ? 'translateY(0)' : 'translateY(24px)',
          transition: 'opacity 0.7s cubic-bezier(0.22, 1, 0.36, 1), transform 0.7s cubic-bezier(0.22, 1, 0.36, 1)',
        }}
      >
        <p className="text-center text-[12px] md:text-[13px] text-[#999] tracking-wide mb-6 md:mb-8">
          Trusted by leading companies worldwide
        </p>
        <div className="flex flex-wrap items-center justify-center gap-6 md:gap-10">
          {companies.map((company, index) => (
            <div
              key={index}
              className="flex items-center gap-2 text-[#BFBFBF] hover:text-[#B8985F] transition-colors cursor-pointer"
            >
              {company.logo ? (
                <img 
                  src={company.logo} 
                  alt={company.name} 
                  className={company.name === 'Stylaverse' ? 'h-12 w-auto object-contain' : 'h-8 w-auto object-contain'}
                  style={company.name === 'Stylaverse' ? { filter: 'contrast(1.2) brightness(0.95)' } : undefined}
                />
              ) : (
                <>
                  <i className={`${company.icon} text-lg w-5 h-5 flex items-center justify-center`}></i>
                  <span className="text-[14px] md:text-[15px] font-medium">{company.name}</span>
                </>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
